import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_CUSTOMERS_DATA } from "./actionTypes";
import {
  fetchCustomersSuccess,
  fetchCustomersFailure,
} from "./actions";

function* fetchCustomersDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/customers",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchCustomersSuccess(response.data));
  } catch (error) {
    yield put(fetchCustomersFailure(error.message));
  }
}

export default function* customersSaga() {
  yield takeEvery(FETCH_CUSTOMERS_DATA, fetchCustomersDataSaga);
}
